import { useState, useEffect } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import Tools from "../utils/Tools";

const HealthStatusAdminPage = () => {
    const [apiRequestHistory, setApiRequestHistory] = useState([]);
    const [stepFunctionsErrorHistory, setStepFunctionsErrorHistory] = useState([]);

    useEffect(() => {
        Tools.sendRequest("get-health-status-admin").then((response) => {
            setApiRequestHistory(response.apiRequestHistory || []);
            setStepFunctionsErrorHistory(response.stepFunctionsErrorHistory || []);
        });
    }, []);

    // Dynamic column generation
    const generateColumns = (data) => {
        if (!data.length) return [];

        return Object.keys(data[0]).map(key => ({
            field: key,
            headerName: key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()),
            sortable: true,
            filter: true,
            resizable: true,
            valueFormatter: (params) => {
                if (typeof params.value === 'object' && params.value !== null) {
                    return JSON.stringify(params.value);
                }
                return params.value;
            }
        }));
    };

    const apiColumns = generateColumns(apiRequestHistory);
    const errorColumns = generateColumns(stepFunctionsErrorHistory);

    return (
        <div style={{ padding: '20px' }}>
            <h2>API Request History</h2>
            <div className="ag-theme-alpine" style={{ height: 400, width: '100%', marginBottom: '30px' }}>
                <AgGridReact
                    rowData={apiRequestHistory}
                    columnDefs={apiColumns}
                    defaultColDef={{
                        flex: 1,
                        minWidth: 100,
                    }}
                />
            </div>

            <h2>Step Functions Error History</h2>
            <div className="ag-theme-alpine" style={{ height: 400, width: '100%' }}>
                <AgGridReact
                    rowData={stepFunctionsErrorHistory}
                    columnDefs={errorColumns}
                    defaultColDef={{
                        flex: 1,
                        minWidth: 100,
                    }}
                />
            </div>
        </div>
    );
};

export default HealthStatusAdminPage;